import { Link } from "react-router";
import { _ } from "i18n";
import type { DiscoverGamesColumnsParams, GameRow } from "./types";

export function discoverGameRowId(row: GameRow): number | null {
	const raw = row.id;
	if (typeof raw === "number" && !Number.isNaN(raw)) {
		return raw;
	}
	if (typeof raw === "string" && raw.length > 0) {
		const n = Number(raw);
		if (!Number.isNaN(n)) {
			return n;
		}
	}
	return null;
}

type DiscoverGameOwner = { id: number; name: string };

export function parseDiscoverGameOwners(value: unknown): DiscoverGameOwner[] {
	if (!Array.isArray(value)) {
		return [];
	}
	const owners: DiscoverGameOwner[] = [];
	for (const item of value) {
		if (item === null || typeof item !== "object") {
			continue;
		}
		const rec = item as Record<string, unknown>;
		const idRaw = rec.id;
		const idNum = typeof idRaw === "number" ? idRaw : Number(idRaw);
		if (!Number.isFinite(idNum) || idNum <= 0) {
			continue;
		}
		const name = typeof rec.name === "string" ? rec.name.trim() : "";
		owners.push({ id: idNum, name });
	}
	return owners;
}

export function parseClubMetadataSide(name: unknown, id: unknown): { name: string | null; idNum: number | null } {
	const n = typeof name === "string" && name.trim() !== "" ? name.trim() : null;
	let idNum: number | null = null;
	if (typeof id === "number" && !Number.isNaN(id)) {
		idNum = id;
	} else if (typeof id === "string" && id !== "") {
		const parsed = Number(id);
		idNum = Number.isNaN(parsed) ? null : parsed;
	}
	return { name: n, idNum };
}

export function clubMetadataSideIsPresent(parsed: { name: string | null; idNum: number | null }): boolean {
	return parsed.name !== null || parsed.idNum !== null;
}

export function renderClubMetadataUser(parsed: { name: string | null; idNum: number | null }) {
	const { name: n, idNum } = parsed;
	if (n !== null && idNum !== null) {
		return (
			<Link to={`/discover/user/${idNum}`} className="discoverGamesTableV3-userLink">
				{n}
			</Link>
		);
	}
	if (n !== null) {
		return n;
	}
	if (idNum !== null) {
		return (
			<Link to={`/discover/user/${idNum}`} className="discoverGamesTableV3-userLink">
				{String(idNum)}
			</Link>
		);
	}
	return "-";
}

export function buildReadOnlyTooltips(params: DiscoverGamesColumnsParams) {
	return {
		cannotEditGameUploads: params.canEditGameUploads
			? undefined
			: _("discover.gamesTable.permission.cannotEditGameUploads"),
		cannotEditAssignee: params.canEditAssignee
			? undefined
			: _("discover.gamesTable.permission.cannotEditAssignee"),
		cannotEditGameStatus: params.canEditGameStatus
			? undefined
			: _("discover.gamesTable.permission.cannotEditGameStatus"),
		cannotEditPriority: params.canEditPriority
			? undefined
			: _("discover.gamesTable.permission.cannotEditPriority"),
	};
}
